// OZAX, MORI, ACECOOK, VINABEEF, THIENLONG, SG LAGER
const FBK_BRAND_IDS_PROD = [1176, 1154, 1242, 1243, 1213, 225];
const FBK_BRAND_IDS_QA = [1096, 1093, 1100, 1101, 1102, 447];

export const getFbkBrandIds = (): number[] =>
  ['qa', 'development'].includes(process.env.APP_ENV || '') ? FBK_BRAND_IDS_QA : FBK_BRAND_IDS_PROD;

export const isFbkBrand = (brandId: string | number): boolean => getFbkBrandIds().includes(Number(brandId));
